module.exports = {
  AllPage: {
    Tel: 'Hotline',
    Us: 'Contact us',
    Copyright: 'Copyright',
    Notnormal: 'Abnormal',
    Pleaseenteraname: 'Name',
    Pleaseenteracontent: 'Content',
    Memo: 'Remarks',
    Time: 'Time',
    PlzChoose: 'Please select',
    Plzchoosetime: 'Please select the date interval',
    OverHandle: 'Over Handle',
    PlzinputSN: 'SN',
    Plzchoosedev: 'Select the device',
    Success: 'Success',
    Sorry: 'Sorry , I lost the page...',
    Cancel: 'Cancel',
    Sure: 'Sure',
    Find: 'Query',
    Add: 'New addition',
    Del: 'Delete',
    Edit: 'Edit',
    Bind: 'Binding',
    Operate: 'Operation',
    More: 'More',
    Save: 'Save',
    Yes: 'Yes',
    No: 'No',
    Stime: 'Start date',
    Etime: 'Ending date',
    Datatime: 'Data time',
    Classification: 'Please select category',
    Plzinput: 'Name or SN',
    Name: 'Name',
    Devname: 'Name',
    Plzstatus: 'Please select the status',
    Alltype: 'All classified',
    Download: 'Download',
    Stop: 'Stop',
    Open: 'Enable',
    Isstop: 'Disable',
    All: 'All',
    Offline: 'Offline',
    Over: 'Over',
    Warning: 'Early Warning',
    Normal: 'Normal',
    OverM: 'Overloaded',
    OverMo: 'Excess',
    Status: 'Status',
    Model: 'Model',
    Type: 'Classify',
    Port: 'Channel',
    Record: 'Record intervals',
    Overps: 'Overps',
    Address: 'Address',
    Overport: 'Channel',
    Show: 'To View',
    Danger: 'Danger',
    Usual: 'Routine',
    Renew: 'Renew',
    Belong:'Belong',
    Look:'See',

  },
  Header: {
    Personal: 'Personal information',
    GoBack: "Return to the cloud platform",
    Drop: "Exit",
    Willbe: "To",
    Expire: "Due",
    upgradeIcon: "Upgrade Icon",
    renewal: "Renew now",
    upgradeNow: "Upgrade Now",
    Noticereminder: "Notice remind",
    Read: "Had read",
    WebAlarm: "Web Alert",
    Datatransfer: "Data transfer",
    Remind: "Remind",
    Msg: "Msg",
    Joincompany: "Join the company",
    Startcompany: "Creating a company",
    Invitationcode: "Invitation code",
    line1: 'Dear users',
    line2: 'In order to serve the users, adapt to the social trend of reform and development, improve the quality of services , the new version of the temperature and humidity data monitoring platform test will be officially online  trial operation on August.3rd, 2018. And all information of users and company in  original monitoring platform test already been moved to the new platform, to make sure the smooth progress of users work , the notice of new platform as below, please cooperate with the implementation. ',
    line3: 'Firstly，system access mode',
    line4: 'Users can access the new version of the temperature and humidity data monitoring platform by clicking on the "Experience Data Monitoring Platform V3 Beta" at the top of the home page of the platform, or by typing in the Url: http://cloud.hzjly.cn/，Old User login name and password with the original temperature and humidity data monitoring platform',
    line5: 'Secondly，Checking Data and information',
    line6: 'Please，old users log on to the new version of the temperature and humidity data monitoring platform after the test service to check whether the relevant data information is wrong, check the scope for',
    line7: '1. Users personal information: user name, real name, gender, mobile phone number, email address, Department, alarm mode',
    line8: '2. Company related information: company name, mobile number, owner, region, detailed address',
    line9: 'If there is any error, please submit the specific problem to the customer service center of Hangzhou luge Technology Co., Ltd',
    line10: 'Thirdly，Main issues',
    line11: 'The new version of temperature and humidity data monitoring platform test service can only be used for historical data query on August 8, 2018. The new version of temperature and humidity data monitoring platform official server online will clear all test service data! For details, please pay attention to the subsequent announcement',
    line12: 'Fourthly，System operation manual',
    line13: 'Please go to the system announcement to download the operation manual, read the operation manual of the new version of the temperature and humidity data monitoring platform test suit, and be familiar with the use method of the new version of the temperature and humidity data monitoring platform test suit. The new version of the temperature and humidity data monitoring platform test service will continue to be built and improved for a period of time after it goes online. I hope that all users will continue to understand and support it as always, and provide more valuable opinions in the use process. If you have any suggestions on the new version of the temperature and humidity data monitoring platform test service, you can directly contact the customer service center of Hangzhou luge Technology Co., Ltd',
  },
  Index: {
    Dev: 'Equipment',
    normal: 'Normal',
    over: 'Over',
    offline: 'Offline',
    allnum: 'Total',

    Monitoringobject: 'Monitoring object',
    ChannelOK: 'Normal',
    Channeloutoflimit: 'Over',
    Channeloffline: 'Offline',
    Channelstop: 'Stops',
    Numberofmonitoringobjects: 'Numbers',

    GPSpositioning: 'GPS Location',
    Latestannouncement: 'Latest announcement',
    Noannouncementyet: 'No announcement',
    Yunxin: 'Yun xin',
    GoMsg: 'Please go to The Yunxin platform to set up SMS service',
    Messagealert: 'Message alert',
    Nonewsyet: 'No news yet',

  },
  Nav: {
    Overview: 'Overview'
  },
  Rule: {
    Alarmrules: 'Alarm rules',
    Pleaseenteranobjectname: 'Object name',
    Name: 'Name',
    Type: 'Type',
    Forcetime: 'Entry-into-force',
    Forcetime2: 'Effective time',
    Permanent: 'Permanent validity',
    Open: 'Enable',
    //ADD
    Addalarmrule: 'New alarm rules',
    Example: 'Example',
    Startdate: 'Start date',
    Enddate: 'End date',
    Alarmlevel: 'Alarm level',
    Level: 'Level',
    SMSalarm: 'SMS alarm',
    Voicealarm: 'Voice alarm',
    WeChatalarm: 'WeChat alarm',
    Platformmessage: 'Platform message',
    Globalobject: 'Global object',
    Specifyuser: 'Specify user',
    Platformusers: 'Platform users',
    contacts: 'Contacts',
    increase: 'Increase',
    Alarmdelay: 'Delay',
    Alarmcycle: 'Cycle',
    Addlevel: 'Add hierarchy',
    Deletelevel: 'Delete hierarchy',
    Rulelist: 'Rules list',
    Grade: 'Level',
    Heuristiccondition: 'Heuristic condition',
    Newcontact: 'New contact',
    Nickname: 'Nickname',
    Telephone: 'Telephone',
    Email: 'Email',
    Addedsuccessfully: 'Success',
    Msg: 'Please binds the rules to the relative device',
    Bindnow: 'Bind now',
    Bindlater: 'Bind later',
    Howalarm: 'How to turn on the WeChat alarm',
    //Bind
    Bindalarm: 'Bind alarm rules',
    Range: 'Range',

    //Detial
    Detial: 'Alarm rule details',
    List: 'Rules list',
    //Edit
    Edit: 'Alarm rules edit',
    //Log
    Log: 'Alarm record',
    AlarmLevel2: 'Alarm level',
    AlarmTime: 'Alarm Time',
    Content: 'Content',
    AlarmUser: 'Alarm User',
  },
  Cold: {
    Coldsystem: 'Cold system',
    Enternumber: 'Enter number',
    Unittype: 'Unit type',
    Unit: 'Unit',
    DevNo: 'Device number',
    Type: 'Type',
    Activationdate: 'Activation date',
    Brandmode: 'Brand mode',
    average: 'Average temperature',
    max: 'Maximum temperature',
    min: 'Minimum temperature',
    alarmtimes: 'Overtemperature alarm times',
    failuresnum: 'Number of equipment failures',
    evaluationvalue: 'Cold-chain evaluation value',

    List: 'Cold-chain equipment list',
    Buytime: 'Time to purchase',
    volume: 'Volume',
    Manufactor: 'Manufacture',
    brand: 'Brand',
    Specification: 'Specification',
    Maintenancerecord: 'Maintenance record',

    evaluationsystem: 'Cold-chain unit evaluation system',
    Excel: 'Excel export',
    Allnum: 'Total number of cold-chain equipment',
    AlarmNum: 'Total number of alarms',
    humancaused: 'Number of human caused',
    nothandledtime: 'Number of times not handled in time',
    noplatform: 'Number of times the platform is not logged in according to the ownership',
  },
  Msg: {
    Messagemanagement: 'Message management',
    Notice: 'Notice',
    Title: 'Title',
    briefintroduction: 'Brief introduction',
    content: 'Content',
    Creationtime: 'Creation time',
  },
  Log: {
    Devlog: 'Device log',
    Monlog: 'Monitor object log',
    Userlog: 'User log',

    selectalevel: 'Please select grade',
    devname: 'Device name',
    contents: 'Contents',
    showlevel: 'Hazard level',
    typename: 'Log Classify',
    username: 'Operator',

    Monname: 'Monitor object name',
    Plzinputmon: 'Please enter the monitor object',
  },
  Dev: {
    user:'Username',
    title:'Title',
    deploy:'Customer Information',
    Devlist: 'Device list',
    Plzlocation: 'Please select location',
    Plzsort: 'Please select sort',
    Sort: 'Sort',
    Card: 'Card',
    localion: 'Location',
    smsinfo: 'SMS overview',
    Expire: 'Expire',
    nosms: 'No SMS',
    Data: 'Log',
    Alarmrule: 'Alarm rules',
    Bindcard: 'Bind card',
    Finish: 'Accomplish',
    Msg1: 'Warning: this operation will delete the device. If you confirm to delete, please proceed as follows',
    Msg2: 'Please enter SN to confirm',
    Msg3: 'Device removed successfully',
    Msg4: 'One click filling',
    Basic: 'Essential information',
    InputCard: 'Card entry',
    Hz: 'Wireless communication frequency',
    Plzhz: 'Please select a frequency',
    Newadd: 'New quantity',
    Newaddcard: 'New card entry',
    Search: 'Search',
    Newdev: 'New device',
    Edittype: 'Classify',
    Cardnum: 'Card number',
    localtype: 'Local type',
    temperature: 'Temperature',
    humidity: 'Humidity',
    portinfo: 'Port information',
    tips: 'Tips',
    Msg5: 'Device synchronization successful',
    Msg6: 'Device synchronization failed',
    Msg7: 'The device is not online and will automatically synchronize after the device is linked',
    Msg8: 'Please wait patiently during device synchronization',
    Devedit: 'Device edit',
    Devdetial: 'Device detail',
    excessive: 'Excessive',
    harbinger: 'Harbinger',
    Msg9: 'Modify channel name',


    devlocation: 'Device location',
    Msg10: 'Refresh time: 1 minute',
    gpslon: 'Longitude',
    gpslat: 'Latitude',
    playback: 'Playback',
    stop: 'Stop',
    speed: 'Playback speed',
    path: 'Running track',
    index: 'Serial number',
    locationtime: 'Location time',
    data: 'Data',
    locationadr: 'Location',

    view: 'Device view',
  },
  DataHandle: {
    msg1: 'Add out of limit transactions',
    msg2: 'Add out of limit transactions',
    time: 'Time',
    reason: 'Over reason',
    overdev: 'Over device',
    overHandle: 'Over Handle',
    operator: 'Operator',
    devnames: 'Device name',
    createtime: 'Create time',

  },
  DevCurve: {
    msg1: 'History curve (equipment)',
    msg2: 'Show upper and lower limits',
    msg3: 'Historical curve (equipment) (Second Edition)',
    portname: 'Channel Name',
    uplow: 'Upper and lower limit',
    max: 'Maximum',
    min: 'Minimum',
    avg: 'Average',
    fc: 'Variance',
    bzc: 'Standard deviation',
  },
  DevHistory: {
    msg1: 'Historical data (device)',
    print: 'Print',
    devsn: 'Device number',
    portdata: 'Port data',
    msg2: 'Over standard data (equipment)',
    msg3: 'Over standard data (equipment) (version 2)',
    msg4: 'Historical data (equipment) (version 2)',

  },
  Mon: {
    MonView: 'Monitor view',
    mon: 'Monitor object',
    bd: 'Stationing',
    fp: 'Distribution',
    xgsxx: 'Modify the upper and lower limit',
    bdt: 'Scatter diagram',
    reupload: 'Upload again',

    title: 'Maintenance record',
    title2: 'Repair equipment',
    register: 'The repair man',
    registertime: 'Repair time',
    registercontent: 'Repair content',
    repairer: 'Repairer',
    repairstate: 'The result of treatment',
    repairtime: 'Repair time',

    title3: 'New monitoring object',
    purchasetime: 'Purchase time',
    img: 'Plan',
    msg: 'Associated',
    title4: 'History curve (monitoring object)',
    NameVal: 'Minimum object name',

    title5: 'Assignment object - assignment',
    msg2: 'Current Location: Monitoring Object',
    msg3: 'Choose',
    Monchild: 'Name',
    createtime: 'Create time',
    msg4: 'Subset selected',
    msg5: 'Selected',

    title6: 'Monitoring object details',
    title7: 'Monitoring object editing',
    title8: 'Historical data (monitoring object)',
    title9: 'Monitoring object',
    title10: 'Over standard data (monitoring object)',
    title11: 'List of monitoring objects',

    msg6: 'Warning',
    msg7: 'This operation will delete the monitoring object. If you confirm to delete, please proceed as follows',
    msg8: 'Please enter the monitoring object name to confirm',
    msg9: 'Name of monitoring object',
    msg10: 'Monitoring object deleted successfully',
    msg11: 'Channel name',
    rebind: 'Reassociate',
    title12: 'Allocation Object',

    name: 'Name',
    tel: 'Tel',
    email: 'Email',
    alarmtype: 'Alarm type',

  },
  JS: {
    //this.$t('JS.devalarm')
    lastweek: 'Last week',
    lastmonth: 'Last month',
    lasttmonth: 'Last three month',
    devalarm: 'Device alarm',
    trans: 'Data transferring....',
    transError: 'Data transfer failed, please contact relevant management....',
    codeinfo: 'Invitation code cannot be empty',
    willdel: 'This operation will be deleted. Do you want to continue?',
    willstop: 'This operation will stop. Do you want to continue?',
    tip: 'Tip',
    sure: 'Sure',
    cancel: 'Cancel',
    msg: 'No data available',
    msg1: 'Please fill in the phone number',
    msg2: 'Please select rules',
    msg3: 'Please select the alarm mode',
    msg4: 'Contact information is empty',
    msg5: 'Please fill in the content correctly',

    one: 'Custom interval',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    show: 'Show',
    hide: 'Hide',
    portval: 'Port value',


    devmsg1: 'Please select a time',
    devmsg2: 'Please fill in the reason for exceeding the standard',
    devmsg3: 'The recording interval cannot be less than the over limit interval',
    devmsg4: 'Please search Sn first for complete channel information',
    devmsg5: 'Data is empty',
    devmsg6: 'The lower limit of exceeding the limit cannot be greater than or equal to the upper limit',
    devmsg7: 'Alert lower limit cannot be greater than or equal to upper limit',
    devmsg8: 'Please input device',
    devmsg9: 'Name length should be less than 5 characters',
    devmsg10: 'Please have at least one card data first',
    devmsg11: 'Please fill in the complete Sn first',
    devmsg12: 'Model cannot be empty',
    devmsg13: 'Record interval cannot be empty',
    devmsg14: 'Out of limit interval cannot be empty',
    devmsg15: 'Please select a classification',
    devmsg16: 'Card information data cannot be empty',
    devmsg17: 'Card data cannot be empty',
    devmsg18: 'Error',

    devmsg19: 'Position all',
    devmsg20: 'Nothing',
    devmsg21: 'Base station Location',
    devmsg22: 'GPS Location',

    srot1: 'Normal sorting',
    srot2: 'Name (positive sequence)',
    srot3: 'Name (reverse order)',
    srot4: 'Sn (positive sequence)',
    srot5: 'Sn (reverse order)',
    srot6: 'Serial number (positive sequence)',
    srot7: 'Serial number (reverse order)',

    viewmsg1: 'The validity period has expired，The following services will be affected',
    viewmsg2: 'Alarm service',
    viewmsg3: 'Historical data query',
    viewmsg4: 'Curve query',
    viewmsg5: 'Positioning track playback',
    viewmsg6: 'Data export',
    viewmsg7: 'Please click the renew button to renew the service',
    viewmsg8: 'Limited service',

    monmsg: 'No distribution',
    monmsg2: 'There is no distribution point to upload the picture. It can only be JPG or PNG format',
    monmsg3: 'Please upload the layout first',
    monmsg4: 'Please select the associated object',
    monmsg5: 'Please input monitoring object',
    monmsg6: 'Purchase time cannot be empty',
    monmsg7: 'Name error',


    indexmsg: 'SMS margin',
    indexmsg2: 'Total quantity',
    indexmsg3: 'Normal',
    indexmsg4: 'Expiring soon',
    indexmsg5: 'Expired',
    indexmsg6: 'SMS service period',


  },

}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js